import { HelmetProvider } from 'react-helmet-async';
import { CookieConsentBanner as CookieConsent } from './components/consent/CookieConsent.jsx';
import { AppRoutes } from './routes';

import { HsAnalytics } from './components/analytics/HsAnalytics.jsx';
export function App() {
  return (
    <HelmetProvider>
      <HsAnalytics />
      <AppRoutes />
      <CookieConsent />
    </HelmetProvider>
  );
}
